import { PepEntity } from '../../../pep-match.model';
import { Component, OnInit, Input, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { compareElements } from 'app/shared/validators/generic-validators';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { unsavedFormCheck } from 'app/shared/validators/generic-validators';

import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';

import { PepMatchRecord } from 'app/entities/monitoring/actual/pep-match.model';
import { PoliticallyExposed } from 'app/shared/models/politically-exposed.model';
import { PoliticallyExposedService } from 'app/entities/monitoring/actual/politicallyexposed/politically-exposed.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';

@Component({
  templateUrl: './update-politically-exposed-info.component.html',
})

/**
 * Dialog component to update Politically Exposed information.
 */
export class UpdatePoliticallyExposedInfoComponent implements OnInit {
  isLoading = false;
  politicallyExposedInfoForm: FormGroup;
  argPoliticallyExposedInfoDetailsData: string;
  argId: number;
  entityTypeId: number;
  argEntityType: string;
  countryTypes: ApplicationValue[];

  Sources = ['Australia', 'Austria', 'Belgium'];

  constructor(private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private politicallyExposedInfoService: PoliticallyExposedService,
    private snackBarService: SnackBarService,
    private warmUpService: WarmUpService,
    private trackingService: TrackingService) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.loadCountriesType();
    // this.updateTaskDetailsDataForm();
  }

  // @todo This function might get updated once REST is available.
  buildForm() {
    this.politicallyExposedInfoForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      comments: [''],
      lastName: ['', Validators.required],
      startDate: [''],
      endDate: [''],
      designation: [''],
      description: [''],
      globalName: [''],
      source: [''],
      country: ['']
    });
  }

  // Method to update task values and display in the dialog.
  updateTaskDetailsDataForm(): void {
    this.entityTypeId = this.argId;
    if (this.argPoliticallyExposedInfoDetailsData) {
      this.politicallyExposedInfoForm.patchValue({
        //generalInfoText: this.argSanctionDetailsData,
      });
    }
  }

  loadCountriesType() {
    const countryList =
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.COUNTRY_TYPE);
    if (countryList instanceof Observable) {
      countryList.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.countryTypes = response.values;
        }
      );
    } else {
      this.countryTypes = countryList;
    }
  }

  // Method to submit the changes for Task Guide text.
  onSubmit({ value, valid }) {
    this.politicallyExposedInfoForm.disable();
    const pepMatchRecord = new PepMatchRecord();
    const pepEntity = new PepEntity();

    pepEntity.startDate = value.startDate;
    pepEntity.endDate = value.endDate;
    pepEntity.description = value.description;
    pepEntity.personId = this.argId;
    pepEntity.lastName = value.lastName;
    pepEntity.firstName = value.firstName;
    pepEntity.country = value.country;
    pepEntity.designation = value.designation;
    pepEntity.globalName = value.globalName;

    pepMatchRecord.comments = value.comments;
    pepMatchRecord.pepEntity = pepEntity;

    this.politicallyExposedInfoService.addPoliticallyExposedMatch(pepMatchRecord, this.entityTypeId)
      .subscribe(response => {
        if (response.flagResult) {
          this.dialogRef.close(pepMatchRecord);
        }
        this.trackingService
          .emitEvent(
          TrackingConstants.ADD_MANUAL_PEP_MATCH,
          TrackingConstants.ADD_MANUAL_PEP_MATCH,
          TrackingConstants.SUCCESS, 1);
        this.callSnackBarService(response);
      }, err => {
        this.trackingService
          .emitEvent(
          TrackingConstants.ADD_MANUAL_PEP_MATCH,
          TrackingConstants.ADD_MANUAL_PEP_MATCH,
          TrackingConstants.FAILURE, 0);
        this.callSnackBarService(err);
      }
      );
  }

  callSnackBarService(response: any) {
    this.snackBarService.showStatus(response,
      MessageService.ADD_PEP_SUCCESS,
      MessageService.ADD_PEP_FAILURE);
  }

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    unsavedFormCheck(event, this.dialogRef, this.politicallyExposedInfoForm);
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/actual/politicallyexposed/politicallyexposedinfo/updatepoliticallyexposedinfo/update-politically-exposed-info.component.ts